import { getData } from '../../../../utils/api'
import { useEffect, useState } from 'react';
import { Footer } from '../../../Footer'
import { CloseOutline, UnorderedListOutline } from 'antd-mobile-icons'
import { getApi } from "../../../../utils/getApi";

import { Swiper, Popup } from 'antd-mobile'

import { SWIPER, PART_FOUR_ITEMS, MEDIAS, NAV_ITEMS } from '../../../HomePage/consts'

import './index.css'

export const ReportXwBox = ({ activePage, setActivePage }) => {

    const [isShowPopup, setIsShowPopup] = useState(false)
    const [path, setPath] = useState('');


    useEffect(() => {
        setPath(getApi)
        if (window.location.search.split('?id=')[1]) {
            getYanzeng()
        } else {
            getList()

        }

    }, []);

    const formatDateString = (dateStr) => {

        // 检查输入是否为 null 或 undefined
        if (dateStr == null) {
            return dateStr; // 或返回默认值，如空字符串 ''
        }

        if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
            return dateStr.replace(/(\d{4})-(\d{2})-(\d{2})/, '$1年$2月$3日');
        }
        return dateStr;
    }

    const [dataSource, setDataSource] = useState({});
    const getList = async () => {
        const res = await getData('/api/user/zhengshu', 'post')
        if (res.data.code == 1) {
            if (window.localStorage.getItem('status')) {
                res.data.data[0].enrollment_time = res.data.data[0].sec_enrollment_time
                res.data.data[0].graduation_time = res.data.data[0].sec_graduation_time
                res.data.data[0].school_name = res.data.data[0].sec_school_name
                res.data.data[0].zhuanye = res.data.data[0].sec_zhuanye
                res.data.data[0].xuezhi = res.data.data[0].sec_xuezhi
                res.data.data[0].xueli_level = res.data.data[0].sec_xueli_level
                res.data.data[0].leibie = res.data.data[0].sec_leibie
                res.data.data[0].xingshi = res.data.data[0].sec_xingshi
                res.data.data[0].is_biye = res.data.data[0].sec_is_biye
                res.data.data[0].certificate_number = res.data.data[0].sec_certificate_number
                res.data.data[0].rector = res.data.data[0].sec_rector
                res.data.data[0].online_code = res.data.data[0].sec_online_code
            }
            setDataSource(res.data.data[0]);
        }
    }

    const getYanzeng = async () => {
        console.log(1);
        const res = await getData('/api/user/yanzheng', 'post', { online_code: window.location.search.split('?id=')[1] })
        if (res.data.code == 1) {
            if (window.location.search.split('?id=')[1] == res.data.data[0].sec_online_code) {
                res.data.data[0].enrollment_time = res.data.data[0].sec_enrollment_time
                res.data.data[0].graduation_time = res.data.data[0].sec_graduation_time
                res.data.data[0].school_name = res.data.data[0].sec_school_name
                res.data.data[0].zhuanye = res.data.data[0].sec_zhuanye
                res.data.data[0].xuezhi = res.data.data[0].sec_xuezhi
                res.data.data[0].xueli_level = res.data.data[0].sec_xueli_level
                res.data.data[0].leibie = res.data.data[0].sec_leibie
                res.data.data[0].xingshi = res.data.data[0].sec_xingshi
                res.data.data[0].is_biye = res.data.data[0].sec_is_biye
                res.data.data[0].certificate_number = res.data.data[0].sec_certificate_number
                res.data.data[0].rector = res.data.data[0].sec_rector
                res.data.data[0].online_code = res.data.data[0].sec_online_code
            }
            setDataSource(res.data.data[0]);
        }
    }

    const navContent = () => {
        return (
            <div className='my-nav'>
                {NAV_ITEMS.map(item => {
                    return (<div className='nav-items'>
                        {item.map(e => {
                            return (
                                <div className="nav-items-item" key={e.key}>
                                    <a href={e.hrefUrl}>{e.text}</a>
                                </div>
                            )
                        })}
                    </div>)
                })}</div>
        )
    }
    const times = (v) => {
        if (v) {

        }
        const timestamp = Number(v + '000')
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        const hours = ('0' + date.getHours()).slice(-2);
        const minutes = ('0' + date.getMinutes()).slice(-2);
        const seconds = ('0' + date.getSeconds()).slice(-2);
        const formattedDate = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes

        return formattedDate
    }

    return (
        <div className='bacscs'>
            <div className="wap-nav-bar"><div className="wap-nav-bar__left">
                <div >
                    <a href="/">
                        <img src="https://t3.chei.com.cn/chsi/assets/gb/wap/images/logo.png" alt="学信网" className="logo" />

                    </a>
                </div> <span className="logo-dot">

                </span> <span className="logo-text"><a href="/xlcx/bgcx.jsp">在线验证

                </a>

                </span>

            </div> <div className="wap-nav-bar__center">

                </div> <div className="wap-nav-bar__right"><span className="ch-nav">
                    <div className="wap-nav-bar__right" style={{ padding: '0' }} onClick={() => setIsShowPopup(true)}>
                        <span className="ch-nav"><UnorderedListOutline /></span>
                    </div>


                </span>

                </div>

            </div>
            <div className="res-wrap"><div className="card"><div className="top-change"><div className="lang-div">
                报告语种
                <a href="javascript:;" className="current">中文
                </a><a href="javascript:;">英文
                </a>
            </div>
			<div title="下载PDF" onClick={() => {
				window.location.href='/report/Xuelidown?vcode=ACZVDTBE6G03X3XY&amp;rid=53147208248462509361002610768517&amp;ln=cn'
				}} className="pdf-div">
			</div>
            </div>  <h3 className="res-h3">教育部学位证书电子注册备案表
                </h3> <div className="img-div"><img src={`${path}${dataSource.avatar}`} width="58" data-caption="个人头像" />
                </div>
                <div class="rowcard">
                    <div class="row">
                        <div class="col-left">姓名</div><div class="col-right namtFamily">{dataSource.username}</div></div>
                    <div class="row"><div class="col-left">性别</div><div class="col-right">{dataSource.gender == 0 ? '女' : '男'}</div></div>
                    <div class="row"><div class="col-left">出生日期</div><div class="col-right">{dataSource.birthday}</div></div>
                    <div class="row"><div class="col-left">获学位日期</div><div class="col-right">{formatDateString(dataSource.degree_time)}</div></div>
                    <div class="row"><div class="col-left">学位授予单位</div><div class="col-right">{dataSource.degree_unit}</div></div>
                    <div class="row"><div class="col-left">所授学位</div><div class="col-right">{dataSource.degree}</div></div>
                    <div class="row"><div class="col-left">学科专业</div><div class="col-right">{dataSource.degree_major}</div></div>
                    <div class="row"><div class="col-left">学位证书编号</div><div class="col-right">{dataSource.degree_num}</div></div>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />

                    <div>

                    </div>
                </div>
            </div>
            </div>

            <Footer />
            {/* 导航弹出层 */}
            {isShowPopup && (<Popup
                visible={isShowPopup}
                onMaskClick={() => {
                    setIsShowPopup(false)
                }}
                onClose={() => {
                    setIsShowPopup(false)
                }}
                position='top'
                bodyStyle={{ height: '' }}
            >
                <div className="my-close-bar">
                    <a href="/wap/">
                        <img src="https://t3.chei.com.cn/chsi/assets/gb/wap/images/logo.png" alt="学信网" className="my-logo" />
                    </a>
                    <CloseOutline onClick={() => setIsShowPopup(false)} />
                </div>
                {navContent()}
            </Popup>)}
        </div >
    )
}